import _ from 'lodash';

export default function selector(storeState) {
    const applists = _.get(storeState, 'mediaPlanForm.applists');
    return {
        applists,
    };
}
